import './Components/styles.css';
import Container from './Components/Container';
import Header from './Components/Header';
import Taller from './Components/Taller';
import Reciclaje from './Components/Reciclaje';
import Importancia from './Components/Importancia';
import Idea from './Components/Idea';
import Beneficios from './Components/Beneficios';
import Desafios from './Components/Desafios';

function App() {
  const photoUrl = 'https://ltuhay.github.io/rosa-recicla/assets/photo.jpg';

  return (
    <div className="app">
      <Container>
        <Header title="Rosa Recicla" photoUrl={photoUrl} />
        <Taller />
        <Reciclaje />
        <Importancia />
        <Idea />
        <Beneficios />
        <Desafios />
      </Container>
    </div>
  );
}
export default App;
